import { prependAccountBaseUrl } from '../utilities/prependUrl';

const EDIT_EMAIL_URL = prependAccountBaseUrl('/account/settings/edit/email');

export { EDIT_EMAIL_URL };
